"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_client_1 = __importDefault(require("apollo-client"));
var apollo_link_http_1 = require("apollo-link-http");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var unfetch_1 = __importDefault(require("unfetch"));
var CB_SERVER_URL = process.env.CB_SERVER_URL;
var httpLink = new apollo_link_http_1.HttpLink({
    uri: "".concat(CB_SERVER_URL, "/graphql"),
    credentials: 'include',
    fetch: unfetch_1.default,
});
var defaultOptions = {
    watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
};
exports.default = new apollo_client_1.default({
    cache: new apollo_cache_inmemory_1.InMemoryCache(),
    link: httpLink,
    defaultOptions: defaultOptions,
});
